export interface AccountPreferenceClass {
  AccountPreferencesId: number
  AccountId: number
  ShowClockStartEnd: boolean
  CultureInfoName: string
  TimeEntryFormat: string
  AccountSessionTimeout: number
  ShowCompletedTasksInTimeShee: boolean
  CurrencySymbol: string
  IsCompanyOwnLogo: boolean
  ScheduledEmailSendTime: Date | undefined
  LastScheduledEmailSentTime: Date | undefined
  Version: string
  FromEmailAddress: string
  FromEmailAddressDisplayName: string
  AccountBaseCurrencyId: number
  AccountReimbursementCurrencyId: number
  LockSubmittedRecords: boolean
  LockApprovedRecords: boolean
  ShowWorkTypeInTimeSheet: boolean
  NumberOfBlankRowsInTimeEntry: number
  ShowCostCenterInTimeSheet: boolean
  WeekStartDay: number
  UserInterfaceLanguage: string
  DefaultTimeEntryMode: string
  PageSize: number
  ShowClientInTimesheet: boolean
  ShowDescriptionInWeekView: boolean
  InvoiceNoPrefix: string
  ShowAdditionalTaskInformationType: number
  TimesheetPrintFooter: string
  ExpenseSheetPrintFooter: string
  ShowCompletedProjectsInTimeSheet: boolean
  ShowProjectForTimeOff: boolean
  ShowTimeOffInTimesheet: boolean
  PasswordExpiryPeriod: boolean
  ShowAllInTimesheetReadOnly: boolean
  ShowTaskInExpenseSheet: boolean
  InvoiceBillingTypeId: number
  ShowBillingRateInInvoiceReport: boolean
  InvoiceFooter: string
  TimesheetOverduePeriods: number
  ShowProjectNameInInvoiceReport: boolean
  ProjectCodePrefix: string
  AutoGenerateProjectCode: boolean
  TimeEntryHoursFormatId: string
  ShowPercentageInTimesheet: boolean
  EnablePasswordComplexity: boolean
  ShowClientDepartmentInProject: boolean
  ShowEntryDateInInvoiceReport: boolean
  TimesheetSort: string
  ShowCostCenterInTimesheetBy: string
  ShowCopyTimesheetButton: boolean
  ShowCopyActivitiesButtonInTimesheet: boolean
  ShowProjectNameInTask: boolean
  ShowClientNameInTask: boolean
  IsShowElectronicSign: boolean
  ShowCompletedProjectInProjectGrid: boolean
  ShowEmployeeNameInInvoiceReport: boolean
  CalculateTaskPercentageAutomatically: boolean
  IncludeCurrentYearInProjectCode: boolean
  ShowAdditionalProjectInformationType: number
  EnableOfflineTimesheet: boolean
  ShowEmployeeProfilePicture: boolean
  ShowWorkTypeInInvoiceDescription: boolean
  ShowClientInExpenseSheet: boolean
  AutomaticallyIncludeAdminitratorInProjectTeam: boolean
  ShowAdditionalDepartmentInformationInEmployee: boolean
  DefaultProjectTaskSelectionInTimesheet: boolean
  InsertDefaultTaskNameInProject: boolean
  DefaultTaskName: string
  RoundOffValueInInvoice: boolean
  IsProjectTemplateMandatory: boolean
  ShowDisableProjectInReport: boolean
  GoogleAppsDomain: string
  IsShowEmployeeNameWithCode: boolean
  IsShowDisableEmployeesInReport: boolean
  EnableGoogleAuthentication: boolean
  SortTaskBy: string
  ShowTimeOffTypesBy: string
  ShowClockStartEndBy: string
  IsTimeOffStatusEditMode: boolean
  AutoResizeTimesheet: boolean
  ShowEmployeeNameBy: number
  HideProjectFromApplication: boolean
  ShowProjectInTimesheet: boolean
  IsShowTimeOffInDays: boolean
  EnableTaskHoursValidation: boolean
  AccountPreferencesGuidId: string
  EnableSingleSignOnSSO: boolean
  SAMLSSOURL: string
  IsAllowOverlappingTimeEntries: boolean
  RemoteLogoutURL: string
  AllocationHoursInProjectTeam: boolean
  TimesheetApprovalTypeBy: string
  ExpenseApprovalTypeBy: string
  UsingSingleSignOnWith: string
  X509Certificate: string
  IsEmailSubscription: boolean
  EmailSubscriptionDate: Date | undefined
  EnableTimerInTimesheet: boolean
  EnableGanttChart: boolean
  EnableUploadFeature: boolean
  NumberOfBlankRowsInTimeOff: number
  ShowFilterInformationOnExport: boolean
  IsAutoCompleteTask: boolean
  IsShowTimeOffPoliciesInDays: boolean
  EmployeeSegregationType: number
  RestrictEntryWithinTaskDateRange: boolean
  GoogleAccessToken: string
  IsCostCenterMandatory: boolean
  HideTimeOffHoursInformation: boolean
  ResetInvoiceNo: boolean
  TimesheetSubmissionMessage: string
  AutoAssignProjectsToEmployeesAndContrariwise: boolean
  DecimalPlaces: number
  AllocationHoursInProjectTaskTeam: boolean
  SubDomain: string
  TimeZoneId: number,
  AssignHolidayTypeIn: number,
  AssignWorkingDayTypeIn: number,
  AssignTimeOffPolicyIn: number,
  AllowZeroHoursInTimesheet: boolean,
  ShowTemplateInTimesheet: boolean,
  CalendarWeekStartDay:string,
  AutoClockOutDelayHours: number
  IsTimesheetApprovalReasonMandatory:boolean
  IsTimesheetChangelogEnabled:boolean
  IsShowConsumedHours: boolean
  // EnableAutoClockOut: boolean
}

const common = {
  AccountPreferencesId: '',
  AccountId: '',
  ShowClockStartEnd: false,
  CultureInfoName: '',
  TimeEntryFormat: 0,
  AccountSessionTimeout: '',
  ShowCompletedTasksInTimeShee: false,
  CurrencySymbol: '',
  IsCompanyOwnLogo: false,
  ScheduledEmailSendTime: new Date(),
  LastScheduledEmailSentTime: new Date(),
  Version: '',
  FromEmailAddress: '',
  FromEmailAddressDisplayName: '',
  AccountBaseCurrencyId: '',
  AccountReimbursementCurrencyId: '',
  LockSubmittedRecords: false,
  LockApprovedRecords: false,
  ShowWorkTypeInTimeSheet: false,
  NumberOfBlankRowsInTimeEntry: '',
  ShowCostCenterInTimeSheet: false,
  WeekStartDay: 0,
  UserInterfaceLanguage: '',
  DefaultTimeEntryMode: '',
  PageSize: 0,
  ShowClientInTimesheet: false,
  ShowDescriptionInWeekView: false,
  InvoiceNoPrefix: '',
  ShowAdditionalTaskInformationType: 0,
  TimesheetPrintFooter: '',
  ExpenseSheetPrintFooter: '',
  ShowCompletedProjectsInTimeSheet: false,
  ShowProjectForTimeOff: false,
  ShowTimeOffInTimesheet: false,
  PasswordExpiryPeriod: false,
  ShowAllInTimesheetReadOnly: false,
  ShowTaskInExpenseSheet: false,
  InvoiceBillingTypeId: 0,
  ShowBillingRateInInvoiceReport: false,
  InvoiceFooter: '',
  TimesheetOverduePeriods: '',
  ShowProjectNameInInvoiceReport: false,
  ProjectCodePrefix: false,
  AutoGenerateProjectCode: false,
  TimeEntryHoursFormatId: '',
  ShowPercentageInTimesheet: false,
  EnablePasswordComplexity: false,
  ShowClientDepartmentInProject: false,
  ShowEntryDateInInvoiceReport: false,
  TimesheetSort: '',
  ShowCostCenterInTimesheetBy: '',
  ShowCopyTimesheetButton: false,
  ShowCopyActivitiesButtonInTimesheet: false,
  ShowProjectNameInTask: false,
  ShowClientNameInTask: false,
  IsShowElectronicSign: false,
  ShowCompletedProjectInProjectGrid: false,
  ShowEmployeeNameInInvoiceReport: false,
  CalculateTaskPercentageAutomatically: false,
  IncludeCurrentYearInProjectCode: false,
  ShowAdditionalProjectInformationType: 0,
  EnableOfflineTimesheet: false,
  ShowEmployeeProfilePicture: false,
  ShowWorkTypeInInvoiceDescription: false,
  ShowClientInExpenseSheet: false,
  AutomaticallyIncludeAdminitratorInProjectTeam: false,
  ShowAdditionalDepartmentInformationInEmployee: false,
  DefaultProjectTaskSelectionInTimesheet: false,
  InsertDefaultTaskNameInProject: false,
  DefaultTaskName: '',
  RoundOffValueInInvoice: false,
  IsProjectTemplateMandatory: false,
  ShowDisableProjectInReport: false,
  GoogleAppsDomain: '',
  IsShowEmployeeNameWithCode: false,
  IsShowDisableEmployeesInReport: false,
  EnableGoogleAuthentication: false,
  SortTaskBy: '',
  ShowTimeOffTypesBy: '',
  ShowClockStartEndBy: '',
  IsTimeOffStatusEditMode: false,
  AutoResizeTimesheet: false,
  ShowEmployeeNameBy: 0,
  HideProjectFromApplication: false,
  ShowProjectInTimesheet: false,
  IsShowTimeOffInDays: false,
  EnableTaskHoursValidation: false,
  AccountPreferencesGuidId: false,
  EnableSingleSignOnSSO: false,
  SAMLSSOURL: '',
  IsAllowOverlappingTimeEntries: false,
  RemoteLogoutURL: '',
  AllocationHoursInProjectTeam: false,
  TimesheetApprovalTypeBy: '',
  ExpenseApprovalTypeBy: '',
  UsingSingleSignOnWith: '',
  X509Certificate: '',
  IsEmailSubscription: false,
  EmailSubscriptionDate: new Date(),
  EnableTimerInTimesheet: '',
  EnableGanttChart: '',
  EnableUploadFeature: false,
  NumberOfBlankRowsInTimeOff: 0,
  ShowFilterInformationOnExport: false,
  IsAutoCompleteTask: false,
  IsShowTimeOffPoliciesInDays: false,
  EmployeeSegregationType: 0,
  RestrictEntryWithinTaskDateRange: false,
  GoogleAccessToken: '',
  IsCostCenterMandatory: false,
  HideTimeOffHoursInformation: false,
  ResetInvoiceNo: false,
  TimesheetSubmissionMessage: '',
  AutoAssignProjectsToEmployeesAndContrariwise: false,
  DecimalPlaces: '',
  AllocationHoursInProjectTaskTeam: false,
  SubDomain: '',
  TimeZoneId: 0,
  AssignHolidayTypeIn: 0,
  AssignWorkingDayTypeIn: 0,
  AssignTimeOffPolicyIn: 0,
  AllowZeroHoursInTimesheet: false,
  ShowTemplateInTimesheet: false,
  CalendarWeekStartDay:'',
  AutoClockOutDelayHours: 0,
  IsTimesheetApprovalReasonMandatory:false,
  IsTimesheetChangelogEnabled:false,
  IsShowConsumedHours: false
  // EnableAutoClockOut: false
};

export const AccountPreferenceInitialsForAdd = {
  ...common,
  countryArray: [],
  CountryId: 0,
  Country: '',
  timeZoneArray: [],
  SystemTimeZoneId: 0,
  SystemTimeZone: '',
  standardFormatArray: [],
  Name: '',
  EnglishName: '',
  invoiceBillingTypeArray: [],
  InvoiceBillingTypeId: '',
  InvoiceBillingType: '',
  systemTimeEntryHoursFormatArray: [],
  SystemTimeEntryHoursFormatId: '',
  SystemTimeEntryHoursFormat: ''
};

export const AccountPreferenceInitialsForUpdate = {
  ...common,
};